import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {useTranslation} from 'react-i18next';
import {Location} from 'history';
import {callNativeWeb, footerShowEventWeb} from 'common/appInterface';
import {CardProductCode} from "../../constants/Card";

const TerminateNotice: React.FC = () => {
	/** Location State */
	const location = useLocation() as Location<LocationState>;
	/** Navigate */
	const navigate = useNavigate();
	/** 다국어처리 */
	const {t, i18n} = useTranslation();

	const screenId = 'SERV19';
	const screenName = t('SERV19.title');

	const [cardInfo] = useState(location.state.info);

	const subContent = useMemo(() => {
		switch (Number(cardInfo.cardProductCode)) {
			case CardProductCode.DreamCard:
				return (<>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DreamCard}.benefit01`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DreamCard}.benefit02`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DreamCard}.benefit03`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DreamCard}.benefit04`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DreamCard}.benefit05`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DreamCard}.benefit06`)}</dd>
				</>)
			case CardProductCode.WelcomeCard:
				return (<>
					<dd className="caption1">{t(`SERV19.${CardProductCode.WelcomeCard}.benefit01`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.WelcomeCard}.benefit02`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.WelcomeCard}.benefit03`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.WelcomeCard}.benefit04`)}</dd>
				</>)
			case CardProductCode.PremierCard:
				return (<>
					<dd className="caption1">{t(`SERV19.${CardProductCode.PremierCard}.benefit01`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.PremierCard}.benefit02`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.PremierCard}.benefit03`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.PremierCard}.benefit04`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.PremierCard}.benefit05`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.PremierCard}.benefit06`)}</dd>
				</>)
			case CardProductCode.DirectCard:
				return (<>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DirectCard}.benefit01`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DirectCard}.benefit02`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DirectCard}.benefit03`)}</dd>
					<dd className="caption1">{t(`SERV19.${CardProductCode.DirectCard}.benefit04`)}</dd>
				</>)
		}
	}, [cardInfo, t]);

	const clickTerminate = useCallback(() => {
			navigate('/terminate/step2', {
				state: {
					query: location.state.query,
					info: location.state.info,
					swiperIndex: location.state.swiperIndex,
					tabIndex: location.state.tabIndex,
					from: location.pathname
				}
			});
		},
		[navigate, location]
	);

	/** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
	const callbackBackKeyEvent = useCallback(() => {
			if (location.state.linkOpenMenu === "main") {
				navigate("/main", {
					state: {
						query: location.state.query,
						swiperIndex: location.state.swiperIndex,
						tabIndex: location.state.tabIndex,
						from: location.pathname
					}
				});
			} else {
				navigate(-1);
			}
		},
		[navigate, location]
	);

	// 최초실행
	useEffect(() => {
		// 언어설정
		i18n.changeLanguage(location.state.query.languageCode);
		// callNative_Web 처리 (WEB > APP)
		callNativeWeb(screenId, screenName, location.state.from === '/intro' ? 'Y' : 'N');
		// 하단바 숨기기
		footerShowEventWeb('N');

		console.log('QUERY STATE');
		console.log(location.state);

		// 최초한번실행 useEffect() Warning 제거
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
	useEffect(() => {
		document.addEventListener('backpress', callbackBackKeyEvent);
		return () => document.removeEventListener('backpress', callbackBackKeyEvent);
	}, [callbackBackKeyEvent]);

	return (
		<section className="pdb70">
			<div id="container">
				<section className="terminate">
					<div className="content">
						<div>
							<span className="title">{t('SERV19.subTitle01')}</span>
						</div>
						<div>
							<span className="text1">{t('SERV19.content01')}</span>
							<dl className="subContent mgt8">
								{subContent}
							</dl>
							<span className="text1">{t('SERV19.content02')}</span>
						</div>
					</div>
					<div className="divider"/>
					<div className="content">
						<div>
							<span className="subTitle">{t('SERV19.subTitle02')}</span>
						</div>
						<div className="cardBox">
							<img src={cardInfo.imgUrl} alt={cardInfo.cardProductCodeName} />
							<div className="subBox">
								<p className="explain mgb8">{cardInfo.cardProductCodeName}</p>
								<p className="explain">{cardInfo.cardNo}</p>
							</div>
						</div>
					</div>
				</section>
				<div className="btnArea">
					<div className="btnWrapTy01">
						<button type="button" className="btnPrimaryTy01" onClick={clickTerminate}>
							<span>{t("COMMON.button.terminate")}</span>
						</button>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TerminateNotice;